import {
  V1_AGENT_AUTHORIZED_PATH,
  V1_AGENT_CONSIDERATION_PATH,
  V1_GET_JOBS_AGENT,
  V1_JOBS_PATH,
  V1_PROPOSITON_PATH,
  V1_SAVE_CONDITION_JOB_SEARCH,
} from '@/constant/routers/path';
import request from '@/services/http.service';

export const getJobSearch = (data: any) => {
  return request(V1_JOBS_PATH, {
    method: 'GET',
    params: data,
  });
};

export const getTokenAuthAgent = () => {
  return request(V1_AGENT_AUTHORIZED_PATH, {
    method: 'GET',
  });
};

export const getAgentJobs = (data: any) => {
  return request(V1_GET_JOBS_AGENT, {
    method: 'GET',
    params: data,
  });
};

export const createAgentConsideration = (id: number) => {
  return request(V1_AGENT_CONSIDERATION_PATH, {
    method: 'POST',
    params: { job_id: id },
  });
};

export const updateAgentConsideration = (id: number) => {
  return request(`${V1_AGENT_CONSIDERATION_PATH}/${id}`, {
    method: 'PATCH',
  });
};

export const createJobProposition = (data: any) => {
  return request(V1_PROPOSITON_PATH, {
    method: 'POST',
    data,
  });
};

export const updateJobProposition = (id: number) => {
  return request(`${V1_PROPOSITON_PATH}/${id}`, {
    method: 'PATCH',
  });
};

export const getListConditionJobSearch = () => {
  return request(V1_SAVE_CONDITION_JOB_SEARCH, {
    method: 'GET',
  });
};

export const deleteConditionJobSearch = (id: number) => {
  return request(`${V1_SAVE_CONDITION_JOB_SEARCH}/${id}`, {
    method: 'DELETE',
  });
};
